import { render } from "./StoresRegisterInfosForm.vue?vue&type=template&id=4228ac97&scoped=true"
import script from "./StoresRegisterInfosForm.vue?vue&type=script&lang=js"
export * from "./StoresRegisterInfosForm.vue?vue&type=script&lang=js"

import "./StoresRegisterInfosForm.vue?vue&type=style&index=0&id=4228ac97&lang=scss&scoped=true"
import "./StoresRegisterInfosForm.vue?vue&type=style&index=1&id=4228ac97&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4228ac97"]])

export default __exports__